import { Button, Card, Col, DatePicker, Flex, Form, Input, Layout, Radio, RadioChangeEvent, Row, Space, Spin, Steps, theme } from "antd";
import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useMutation, useQuery } from "react-query";
import { PageHeaderSection } from "../../components/common/PageHeadSection";
import { SFModal } from "../../components/elements/SFModal";
import { mdlPDFRendererProps } from "../../models/ui-models/PDFRendererProps";
import { enmPdfRendererType } from "../../models/enums/PdfRenderer";
import { useAppDispatch, useAppSelector } from "../../store/Hooks";
import { setPdfExportObject } from "../../store/SiteSlice";
import { enmPdfExportType } from "../../models/enums/PdfExportType";
import { toast } from "react-toastify";
import { ObjectHelper } from "../../utils/ObjectHelper";
import { TransferDirection } from "antd/es/transfer";
import { Content, Header } from "antd/es/layout/layout";
import { mdlStopFreeSaleHotelAgencyMarketRequest } from "../../models/service-models/stop-free-sale/StopFreeSaleHotelAgencyMarketRequest";
import _ from "lodash";
import { mdlStopFreeSaleCreateRequest } from "../../models/service-models/stop-free-sale/StopFreeSaleCreateRequest";
import { mdlStopFreeSaleCreateParams } from "../../models/domain/value-objects/StopFreeSaleCreateParams";
import { HotelSelect } from "../../components/common/HotelSelect";
import { enmActionType } from "../../models/enums/ActionType";
import dayjs, { Dayjs } from "dayjs";
import { mdlIdCodeNamePair } from "../../models/domain/IdCodeNamePair";
import { DateRangePicker } from "../../components/common/DateRangePicker";
import { mdlKeyTitlePair } from "../../models/domain/value-objects/KeyTitlePair";
import { useLocation, useNavigate } from "react-router-dom";
import { enmStopFreeSale } from "../../models/enums/StopFreeSale";
import { StopFreeSaleService } from "../../services/StopFreeSaleService";
import TextArea from "antd/es/input/TextArea";
import { InputHelper } from "../../utils/InputHelper";
import { mdlStopFreeSaleExport } from "../../models/domain/StopFreeSaleExport";
import { StopFreeSaleExportEmail } from "../../components/stop-free-sale/StopFreeSaleExportEmail";
import { StopFreeSaleAppTypeSelect } from "../../components/stop-free-sale/StopFreeSaleAppTypeSelect";
import { AgencyEmailTemplate } from "../../components/stop-free-sale/AgencyEmailTemplate";
import { mdlStopFreeSaleDetail } from "../../models/domain/StopFreeSaleDetail";
import { mdlStopFreeSaleMessage } from "../../models/domain/StopFreeSaleMessage";
import { mdlStopFreeSaleDetailRequest } from "../../models/service-models/stop-free-sale/StopFreeSaleDetailRequest";
import { AgencyMarketService } from "../../services/AgencyMarketService";
import { mdlAgencyMarketListRequest } from "../../models/service-models/agency-market/AgencyMarketListRequest";
import { HotelRoomNameSelect } from "../../components/common/HotelRoomNameSelect";
import { mdlStopFreeSaleSaveRequest } from "../../models/service-models/stop-free-sale/StopFreeSaleSaveRequest";
import { HotelRoomTypeSelect } from "../../components/common/HotelRoomTypeSelect";
import { mdlStopFreeSaleRoomTypesRequest } from "../../models/service-models/stop-free-sale/StopFreeSaleRoomTypesRequest";
import { mdlStopFreeSale } from "../../models/domain/StopFreeSale";
import { enmStopFreeSaleAppType } from "../../models/enums/StopFreeSaleAppType";
import { mdlStopFreeSaleSendRequest } from "../../models/service-models/stop-free-sale/StopFreeSaleSendRequest";
import { mdlStopFreeSaleMailServiceRequest } from "../../models/service-models/stop-free-sale/StopFreeSaleMailServiceRequest";
import { mdlHotelRoomTypeListRequest } from "../../models/service-models/hotel/HotelRoomTypeListRequest";
import { DefinitionService } from "../../services/DefinitionService";
import { routeContants } from "../../utils/RouteConstants";
import { Key } from "antd/es/table/interface";
import CustomTransfer from "../../components/common/CustomTransfer";
export const StopFreeSaleCreate = () => {
    const navigate = useNavigate();
    const location = useLocation();
    const { token } = theme.useToken();
    const { t } = useTranslation();
    const [current, setCurrent] = useState(0);
    const [marketFilterRequest, setMarketFilterRequest] = useState<mdlAgencyMarketListRequest>({ allMarkets: false });
    const [selectedAgenciesObject, setSelectedAgenciesObject] = useState<string[]>();
    const [stopFreeSaleCreateRequest, setStopFreeSaleCreateRequest] = useState<mdlStopFreeSaleCreateRequest>({ agencies: [] });
    const dispatch = useAppDispatch();
    const [form] = Form.useForm();
    const [selectedHotel, setSelectedHotel] = useState<string>();
    const [stopFreeSaleType, setStopFreeSaleType] = useState<enmStopFreeSale>(enmStopFreeSale.StopSale);
    const responsiveCol = window.innerWidth > 660 ? 12 : 24;
    const [openAgencyEmailModal, setOpenAgencyEmailModal] = useState<boolean>(false);
    const [exportData, setExportData] = useState<mdlStopFreeSaleExport>();
    const [boardDisableStatus, setBoardDisableStatus] = useState<boolean>(false);
    const [openEmailModal, setOpenEmailModal] = useState<boolean>(false);
    const [detailData, setDetailData] = useState<mdlStopFreeSaleDetail[]>();
    const [message, setMessage] = useState<mdlStopFreeSaleMessage>();
    const [selectedRoomTypes, setSelectedRoomTypes] = useState<string[]>();
    const [activeItem, setActiveItem] = useState<mdlStopFreeSale>();
    const [activeSpin, setActiveSpin] = useState<boolean>(false);
    const emptyGuid = "00000000-0000-0000-0000-000000000000";
    const [activeAgency, setActiveAgency] = useState<mdlStopFreeSaleDetail>();
    const [clearCustomTransferData, setClearCustomTransferData] = useState<boolean>(false);
    const siteStore = useAppSelector((state) => state.site);

    const {
        data: transferData,
        isLoading: isLoadingTransferData,
        refetch: refetchTransferDataData
    } = useQuery(
        ["getHotelAgencyList", marketFilterRequest],
        () => {
            if (marketFilterRequest && selectedHotel)
                return AgencyMarketService.HotelAgencyList(marketFilterRequest);

        },
        {
            refetchOnWindowFocus: false,
            enabled: !!selectedHotel,
            onSuccess(data) {
                console.log(data?.body?.data?.map(obj => ({
                    key: (obj.key && obj.key.length > 0) ? obj.key : "null",
                    title: obj?.title,
                    children: obj.children ? obj.children.map(chd => ({
                        key: `${((obj.key && obj.key.length > 0) ? `${obj.key}_` : "null_")}${chd.key!}`,
                        title: chd?.title,
                        parent: {
                            key: `${(!obj.key ? "null_" : "")}${chd.key!}`,
                            title: chd?.title,
                        }
                    })) : [] as mdlKeyTitlePair
                })) as mdlKeyTitlePair[])
            },
        }
    );

    const {
        data: roomAndTypeListData,
        isLoading: isLoadingRoomAndType,
        refetch: reFetchRoomAndTypeList
    } = useQuery(
        ["getHotelRoomAndTypes", selectedHotel],
        () => {
            if (selectedHotel)
                return DefinitionService.HotelRoomAndTypeList({ pageSize: 0, hotelId: selectedHotel } as mdlHotelRoomTypeListRequest);
        },
        {
            refetchOnWindowFocus: false,
            enabled: !!selectedHotel
        }
    );

    const { mutateAsync: create, isLoading: createLoading, data: createData } = useMutation(
        (request: mdlStopFreeSaleSendRequest) => StopFreeSaleService.SendRecord(request),
        {
            onMutate(variables) {
            },
            onError: error => {
                console.log(error);
            },
            onSuccess(data, variables, context) {
                if (data.header && data.header.success) {
                    toast.success(t("common.success"));
                }
                else {
                    toast.error(ObjectHelper.getErrorMessage(data.header.messages));
                }
            },
        }
    );

    const handleCreate = () => {
        if (selectedAgenciesObject == null) {
            toast.error(t("stopFreeSale.create.agenciesEmptyError"));
            return;
        }
        else {
            create({ stopFreeId: exportData?.id });
        }
    }

    useEffect(() => {
        if (location && location.state && location.state.type) {
            setStopFreeSaleType(location.state.type)
        }
        if (location && location.state && location.state.data) {
            const active = location.state.data as mdlStopFreeSale;
            setActiveItem(active);
            setSelectedHotel(active.hotelId)
            form.setFieldsValue({
                dateStart: dayjs(active.startDate, "DD-MM-YY"),
                dateEnd: dayjs(active.endDate, "DD-MM-YY"),
                appType: active.type ? enmStopFreeSaleAppType.AccommodationBased : enmStopFreeSaleAppType.EntryBased
            });
            setMarketFilterRequest({ ...marketFilterRequest, ["hotelId"]: active.hotelId });
        }
    }, [])


    const {
        data: marketFilterData,
        isLoading: isLoadingMarketFilterData,
        refetch: refetchMarketFilterData
    } = useQuery(
        ["getHotelAgencyMarket"],
        () => {
            if (activeItem)
                return StopFreeSaleService.GetHotelAgencyMarket({ stopFreeId: activeItem.id } as mdlStopFreeSaleHotelAgencyMarketRequest);
        },
        {
            refetchOnWindowFocus: false,
            enabled: !!activeItem && activeItem.id != emptyGuid && !isLoadingTransferData,
            onSuccess(data) {
                if (data && data.body && data.body.data && transferData && transferData.body && transferData.body.data) {
                    const firstItem = _.first(transferData.body.data) as any;
                    if (firstItem?.marketId == "") {
                        setMarketFilterRequest({ ...marketFilterRequest, ["allMarkets"]: true })
                    }
                    const selectedAgencies = data.body.data.map((x: any) => { return { title: x.agencyId, key: `${x.agencyId}`, children: null } as any });
                    const parentSelectedAgencies = selectedAgencies.filter(x => !x.key.includes('_'));
                    const subSelectedAgencies = selectedAgencies.filter(x => x.key.includes('_'));
                    const dontHaveSubsParentAgencies = parentSelectedAgencies.filter(x => !subSelectedAgencies.find(y => y.key.includes(x.key)));
                    const flatData = flattenData(transferData.body?.data);
                    const shouldBeAddSubAgencies = dontHaveSubsParentAgencies.map(x =>
                        flatData?.find(y => y.key?.includes(x.key))
                    ).flat().filter(x => x != undefined);
                    const createRequest = ({ ...stopFreeSaleCreateRequest, ["agencies"]: shouldBeAddSubAgencies.map((x: any) => { return { title: x.key, key: `${x.key}`, children: null } as any }) as mdlKeyTitlePair[] });
                    setStopFreeSaleCreateRequest(createRequest);
                    setSelectedAgenciesObject(shouldBeAddSubAgencies.map(x => x.key));
                }
            },
        }
    );


    const transformSelectedKeys = (response: any | any[]): string[] => {
        const responses = Array.isArray(response) ? response : [response];
        return responses.map(item => `${item.marketId}_${item.agencyId}`);
    };

    const flattenData = (data: any, parent = null as any) => {
        let flatList = [] as any[];
        data.forEach((item: any) => {
            const itemWithParentKey = {
                ...item,
                key: parent ? `${parent.key}_${item.key}` : item.key,
                parentKey: parent ? parent.key : null,
            };
            flatList.push(itemWithParentKey);
            if (item.children) {
                flatList = [...flatList, ...flattenData(item.children, item)];
            }
        });

        return flatList;
    };

    const {
        data: stopFreeDetail,
        isLoading: isLoadingStopFreeDetail,
        refetch: refetchStopFreeDetail
    } = useQuery(
        ["getDetail"],
        () => {
            if (activeItem)
                return StopFreeSaleService.GetDetail({ stopFreeId: activeItem.id } as mdlStopFreeSaleDetailRequest);
        },
        {
            refetchOnWindowFocus: false,
            enabled: !!activeItem && activeItem.id != emptyGuid,
            onSuccess(data) {
                if (data && data.body && data.body.data) {
                    const firstItem = _.first(data.body.data);
                    form.setFieldValue("note", firstItem?.note);
                    if (firstItem?.roomId) {
                        form.setFieldValue("room", firstItem?.roomId);
                    }
                }
            },
        }
    );
    const {
        data: stopFreeRoomTypes,
        isLoading: isLoadingStopFreeRoomTypes,
        refetch: refetchStopFreeRoomTypes
    } = useQuery(
        ["getRoomTypes"],
        () => {
            if (activeItem)
                return StopFreeSaleService.GetRoomTypes({ stopFreeId: activeItem.id } as mdlStopFreeSaleRoomTypesRequest);
        },
        {
            refetchOnWindowFocus: false,
            enabled: !!activeItem && activeItem.id != emptyGuid && roomAndTypeListData != undefined,
            onSuccess(data) {
                if (data && data.body && data.body.data) {
                    const selectableRoomTypes: string[] = data.body.data.filter(x => roomAndTypeListData?.body?.data?.find((y: any) => y.roomTypeId == x));
                    form.setFieldValue("roomType", selectableRoomTypes);
                    setSelectedRoomTypes(selectableRoomTypes)
                    if (selectableRoomTypes.length > 1) {
                        setBoardDisableStatus(true);
                    }
                }
            },
        }
    );

    const getMailService = useMutation({
        mutationFn: (id: string) => {
            return StopFreeSaleService.GetMailService({ stopFreeId: id } as mdlStopFreeSaleMailServiceRequest)
        },
    })

    const mailMutateOperations = (id: string, fnFunc: Function) => {
        setActiveSpin(true);
        setExportData(undefined);
        setMessage(undefined);
        setDetailData(undefined);
        getMailService.mutate(id, {
            onSuccess(data) {
                if (data && data.body && data.header.success) {
                    setExportData(({ ..._.first(data.body.mailData), ["id"]: id }) as mdlStopFreeSaleExport);
                    setMessage(data.body.messages);
                    setDetailData(data.body.details?.map(x => ({ ...x, ["id"]: id })))
                    fnFunc && fnFunc();
                }
            }, onSettled(data, error, variables, context) {
                setActiveSpin(false);
            },
        })
    }

    const next = () => {
        if (current == 0 && selectedAgenciesObject?.length == 0)
            toast.error(t("stopFreeSale.create.chooseAgency"));
        else {
            if (current == 1) {
                var validateRequiredFields = new Array<string>();
                if (InputHelper.isNullOrUndefinedOrEmpty(form.getFieldValue("roomType"))) {
                    validateRequiredFields.push(t("stopFreeSale.create.roomType"));
                }
                if (InputHelper.isNullOrUndefinedOrEmpty(form.getFieldValue("appType"))) {
                    validateRequiredFields.push(t("stopFreeSale.create.appType"));
                }
                if (InputHelper.isNullOrUndefinedOrEmpty(form.getFieldValue("board")) && selectedRoomTypes && selectedRoomTypes?.length <= 1) {
                    validateRequiredFields.push(t("stopFreeSale.create.room"));
                }
                if (InputHelper.isNullOrUndefinedOrEmpty(form.getFieldValue("dateStart")) || InputHelper.isNullOrUndefinedOrEmpty(form.getFieldValue("dateEnd"))) {
                    validateRequiredFields.push(t("stopFreeSale.create.accomDate"));
                }
                if (validateRequiredFields.length == 0) {
                    form.submit();
                }
                else {
                    toast.error(<>{t("stopFreeSale.create.actionValidationFailed")} <br /> {_.uniq(validateRequiredFields).join(",")}</>)
                }
            }
            else {
                setCurrent(current + 1);
            }
        }

    };

    const saveStopFree = useMutation({
        mutationFn: (request: mdlStopFreeSaleSaveRequest) => {
            return StopFreeSaleService.SaveStopFree(request)
        },
    })

    const prev = () => {
        if (current == 0) {
            navigate(routeContants.STOP_FREE_SALE_ADD);
            return;
        }
        const newPageNumber = current - 1;
        setCurrent(newPageNumber);
    };


    const handleChange = (
        newTargetKeys: Key[],
        direction: TransferDirection,
        moveKeys: Key[]
    ) => {
        setSelectedAgenciesObject(newTargetKeys as string[]);
    };

    const handleHotelChange = (value: mdlIdCodeNamePair) => {
        form.resetFields();
        form.setFieldValue("hotelId", value.id);
        form.setFieldValue("hotelName", value.localName);
        setSelectedHotel(value.id);
        setMarketFilterRequest({ ...marketFilterRequest, ["hotelId"]: value.id });
        setSelectedAgenciesObject([]);
        setClearCustomTransferData(true);
        setStopFreeSaleCreateRequest({ agencies: [] });
    }

    const handleRoomTypeDeselect = (value: any) => {
        let selectedItems = (_.cloneDeep(selectedRoomTypes) ?? []);
        if (value) {
            selectedItems = selectedItems.filter(x => x != value.roomTypeId);
        } else {
            selectedItems = [];
        }
        setSelectedRoomTypes(selectedItems);
        if (selectedItems && selectedItems.length > 1) {
            form.setFieldValue("board", undefined);
            setBoardDisableStatus(true)
        } else {
            form.setFieldValue("roomType", undefined);
            form.setFieldValue("board", undefined);
            setBoardDisableStatus(false)
        }
    }

    const handleRoomTypeChange = (value: any) => {
        const firstObj: any = Array.isArray(value) ? _.first(value) : value;
        const _selected = Array.isArray(value) ? value?.map((x: any) => (x.roomTypeId == undefined ? x : x.roomTypeId)) : value;
        setSelectedRoomTypes(_selected);
        if (firstObj) {
            form.setFieldValue("roomTypeName", firstObj.name);
            form.setFieldValue("roomType", value);
        }
        if (_selected && _selected.length > 1) {
            form.setFieldValue("board", undefined);
            setBoardDisableStatus(true)
        } else {
            setBoardDisableStatus(false);

        }
    }

    const handleBoardChange = (value: mdlIdCodeNamePair) => {
        form.setFieldValue("room", value.id);
        form.setFieldValue("roomName", value.name);
    }

    const handleLastStep = async (values: mdlStopFreeSaleCreateParams) => {
        try {
            const emtpyText = "";
            const allText = "Hepsi";

            if (values && activeItem) {
                values.dateStart = dayjs(values.dateStart).add(1, 'day').toDate();
                values.dateEnd = dayjs(values.dateEnd).add(1, 'day').toDate();
            }

            const request = {
                id: activeItem?.id,
                type: (stopFreeSaleType && stopFreeSaleType as enmStopFreeSale == enmStopFreeSale.FreeSale ? true : false),
                hotelId: selectedHotel,
                marketAgencies: selectedAgenciesObject?.map(x => x.replace("null_null_", "null_").replace("undefined_", "null_")),
                startDate: values.dateStart,
                endDate: values.dateEnd,
                roomType: selectedRoomTypes,
                room: values.board ? (values.board as any).id : emptyGuid,
                guarantyQuata: true,
                stopFreeNote: values.note,
                isSend: false,
                checkInStay: 1,
                stopFreeName: emtpyText,
                hotelName: values.hotelName,
                roomTypeName: values.roomTypeName,
                roomName: values.roomName ?? emtpyText,
                board: emptyGuid,
                boardName: allText,
                sellableRoomCount: undefined,
                roomTypeSellable: emptyGuid,
                roomTypeSellableName: allText,
                boardSellable: emptyGuid,
                boardSellableName: allText,
                roomSellable: emptyGuid,
                roomSellableName: allText,
                optionDay: (stopFreeSaleType && stopFreeSaleType as enmStopFreeSale == enmStopFreeSale.FreeSale ? undefined : 0),
                stopFreeSubject: emtpyText,
            } as mdlStopFreeSaleSaveRequest;

            setActiveSpin(true);
            saveStopFree.mutate(request, {
                onSuccess(data) {
                    if (data && data.body && data.body && data.body.isSuccessful && data.body.message) {
                        handleEmailClick(data.body.message);
                        if (activeItem) {
                            let active = _.cloneDeep(activeItem);
                            active.id = data.body.message;
                            setActiveItem(active)
                        }
                        setCurrent(current + 1);
                    }
                },
                onSettled(data, error, variables, context) {
                    setActiveSpin(false)
                },
            });
        } catch (error) {
            console.error('Validation failed:', error);
            setActiveSpin(false);
        }
    };


    const handleAgencyMailPreview = (e: any) => {
        setActiveAgency(e);
        if (e.id == exportData?.id) {
            setOpenAgencyEmailModal(true);
            return;
        }
        mailMutateOperations(e.id, (data: any) => { setOpenAgencyEmailModal(true) });
    }
    const handleEmailClick = (id: string) => {
        if (InputHelper.isNullOrUndefinedOrEmpty(id) || id == exportData?.id) {
            return;
        }
        mailMutateOperations(id, (data: any) => { setOpenEmailModal(true) });
    }
    const handleNewActionSendMail = (id: string) => {
        if (InputHelper.isNullOrUndefinedOrEmpty(id) || id == exportData?.id) {
            setOpenEmailModal(true);
            return;
        }
        mailMutateOperations(id, (data: any) => { setOpenEmailModal(true) });
    }

    const handlePrint = (id: string) => {
        if (InputHelper.isNullOrUndefinedOrEmpty(id) || id == exportData?.id) {
            var exportProps: mdlPDFRendererProps = {
                params: { dataSource: exportData, message: message, detail: detailData },
                rendererType: enmPdfRendererType.StopFreeSaleTemplate,
                type: enmPdfExportType.PRINT
            }
            dispatch(setPdfExportObject(exportProps));
            return;
        }
        mailMutateOperations(id, (data: any) => {
            var exportProps: mdlPDFRendererProps = {
                params: { dataSource: exportData, message: message, detail: detailData },
                rendererType: enmPdfRendererType.StopFreeSaleTemplate,
                type: enmPdfExportType.PRINT
            }
            dispatch(setPdfExportObject(exportProps));
        });
    }

    const handleExport = (id: string) => {
        if (InputHelper.isNullOrUndefinedOrEmpty(id) || id == exportData?.id) {
            var exportProps: mdlPDFRendererProps = {
                params: { dataSource: exportData, message: message, detail: detailData },
                rendererType: enmPdfRendererType.StopFreeSaleTemplate,
                type: enmPdfExportType.PDF
            }
            dispatch(setPdfExportObject(exportProps));
            return;
        }
        mailMutateOperations(id, (data: any) => {
            var exportProps: mdlPDFRendererProps = {
                params: { dataSource: exportData, message: message, detail: detailData },
                rendererType: enmPdfRendererType.StopFreeSaleTemplate,
                type: enmPdfExportType.PDF
            }
            dispatch(setPdfExportObject(exportProps));
        });
    }

    const getMinDate = () => {
        if (!activeItem || activeItem.startDate == null) {
            return dayjs(dayjs(), "DD-MM-YYYY")
        }
        return dayjs(activeItem.startDate, "DD-MM-YY");
    }


    const getSelectedType = () => {
        if (!roomAndTypeListData || !selectedRoomTypes) {
            return undefined;
        }
        const result = roomAndTypeListData.body?.data?.find((x: any) => x.roomTypeId == _.first(selectedRoomTypes)) as any

        return result ? result.hotelRoomTypeId : undefined;
    }

    const handleStopFreeTypeChange = (e: RadioChangeEvent) => {
        setSelectedAgenciesObject([]);
        setClearCustomTransferData(true);
        setStopFreeSaleCreateRequest({ agencies: [] });
        setMarketFilterRequest({ ...marketFilterRequest, ["allMarkets"]: e.target.value });
    }
    let steps = [
        {
            title: t("stopFreeSale.create.wizardFirst"),
            content:
                <Layout>
                    <Header style={{ backgroundColor: "transparent" }} className="mt-4 ">
                        <Row gutter={24}>
                            <Col span={responsiveCol}>
                                <Form.Item<mdlStopFreeSaleCreateParams>
                                    label={t("stopFreeSale.create.hotel")}
                                    name="hotelId"
                                    rules={[{ required: true, message: t("common.required") }]}
                                    className="mt-3 pe-2"
                                >
                                    <HotelSelect sendObject={true} onChange={(value: mdlIdCodeNamePair) => handleHotelChange(value)} defaultValue={selectedHotel} />
                                </Form.Item>
                            </Col>
                            <Col span={responsiveCol}>
                                <div className="ps-2">
                                    <Space>
                                        <label>{t("stopFreeSale.create.markets")}</label>

                                        <Radio.Group onChange={(e: RadioChangeEvent) => handleStopFreeTypeChange(e)} value={marketFilterRequest.allMarkets}>
                                            <Radio value={false}>{t("stopFreeSale.create.choose")}</Radio>
                                            <Radio value={true}>{t("stopFreeSale.create.all")}</Radio>
                                        </Radio.Group>
                                    </Space>
                                </div>
                            </Col>
                        </Row>
                    </Header>
                    <Content className="mb-4 ps-4 pe-4">
                        <Row>
                            <Col span={24}>
                                {
                                    selectedHotel &&
                                    <>
                                        <CustomTransfer
                                            dataSource={transferData?.body?.data?.map(obj => ({
                                                key: obj.key! ?? "null",
                                                title: obj?.title,
                                                children: obj.children ? obj.children.map(chd => ({
                                                    key: `${((obj.key && obj.key.length > 0) ? "" : "null_")}${chd.key!}`,
                                                    title: chd?.title,
                                                    parent: {
                                                        key: `${((obj.key && obj.key.length > 0) ? obj.key : "null")}`,
                                                        title: chd?.title,
                                                    }
                                                })) : [] as mdlKeyTitlePair
                                            })) as mdlKeyTitlePair[]}
                                            selectedKeys={selectedAgenciesObject}
                                            onChange={handleChange}
                                            parentChangeStatus={clearCustomTransferData}
                                            parentChangeFunction={() => { setClearCustomTransferData(false) }}
                                        />


                                    </>
                                }
                            </Col>
                        </Row>
                    </Content>
                </Layout>
        },
        {
            title: stopFreeSaleType == enmStopFreeSale.FreeSale ? t("stopFreeSale.create.freeSale") : t("stopFreeSale.create.stopSale"),
            content:
                <Layout>
                    <Content >
                        <Form
                            form={form}
                            name="spo-form"
                            initialValues={{ spoType: Number(enmActionType.ENTRY_BASED) }}
                            layout="vertical"
                            onFinish={(values: mdlStopFreeSaleCreateParams) => handleLastStep(values)}
                            autoComplete="off"
                            className="p-4"
                        >
                            <Row gutter={16}>

                                <Form.Item name="hotelName" hidden>
                                    <Input />
                                </Form.Item>
                                <Form.Item name="roomName" hidden>
                                    <Input />
                                </Form.Item>
                                <Form.Item name="roomTypeName" hidden>
                                    <Input />
                                </Form.Item>
                                <Form.Item name="dateStart" hidden>
                                    <DatePicker />
                                </Form.Item>
                                <Form.Item name="dateEnd" hidden>
                                    <DatePicker />
                                </Form.Item>
                                <Col span={12}>
                                    <Form.Item<mdlStopFreeSaleCreateParams>
                                        name="dateStart"
                                        label={t("stopFreeSale.create.accomDate")}
                                        rules={[{ required: true, message: t("common.required") }]}
                                    >
                                        <DateRangePicker
                                            endOfStatus={false}
                                            minDate={getMinDate()}
                                            fromValue={form.getFieldValue("dateStart")}
                                            toValue={form.getFieldValue("dateEnd")}
                                            mode={activeItem ? 'edit' : 'create'}
                                            onChange={(dates) => {
                                                if (dates) {
                                                    form.setFieldsValue({
                                                        dateStart: dates[0],
                                                        dateEnd: dates[1],
                                                    });
                                                } else {
                                                    form.setFieldsValue({
                                                        dateStart: null,
                                                        dateEnd: null,
                                                    });
                                                }
                                            }}
                                            placeholder={[t("stopFreeSaleTable.startDate"), t("stopFreeSaleTable.endDate")]}
                                        />
                                    </Form.Item>
                                </Col>
                                <Col span={12}>
                                    <Form.Item<mdlStopFreeSaleCreateParams>
                                        label={t("stopFreeSale.create.appType")}
                                        name="appType"
                                        rules={[{ required: true, message: t("common.required") }]}
                                    >
                                        <StopFreeSaleAppTypeSelect />
                                    </Form.Item>
                                </Col>
                            </Row>

                            <Row gutter={16}>
                                <Col span={12}>
                                    <Form.Item<mdlStopFreeSaleCreateParams>
                                        label={t("stopFreeSale.create.roomType")}
                                        name="roomType"
                                        rules={[{ required: true, message: t("common.required") }]}
                                    >
                                        <HotelRoomTypeSelect
                                            fnSelectAll={handleRoomTypeChange}
                                            fnClearAll={handleRoomTypeDeselect}
                                            sendObject={true}
                                            mode="multiple"
                                            onChange={handleRoomTypeChange}
                                            onDeselect={handleRoomTypeDeselect} hotelId={selectedHotel} />
                                    </Form.Item>
                                </Col>
                                <Col span={12}>
                                    <Form.Item<mdlStopFreeSaleCreateParams>
                                        label={t("stopFreeSale.create.room")}
                                        name="board"
                                        rules={[{ required: false, message: t("common.required") }]}
                                    >
                                        <HotelRoomNameSelect detail={stopFreeDetail?.body?.data} onChange={(value: mdlIdCodeNamePair) => handleBoardChange(value)} sendObject={true} hotelId={selectedHotel} typeId={getSelectedType()} disabled={boardDisableStatus} />
                                    </Form.Item>
                                </Col>
                            </Row>
                            <Row>

                                <Col span={24}>
                                    <Form.Item<mdlStopFreeSaleCreateParams>
                                        label={t("stopFreeSale.create.note")}
                                        name="note"
                                        rules={[{ required: false, message: t("common.required") }]}
                                    >
                                        <TextArea />
                                    </Form.Item>
                                </Col>
                            </Row>
                        </Form>
                    </Content>
                </Layout>
        },
        {
            title: t("stopFreeSale.create.wizardThird"),
            content:
                <Layout>
                    <Content className="p-4">
                        <Spin spinning={activeSpin} delay={500}>
                            <StopFreeSaleExportEmail showSendButton={false} stopFreeSaleType={stopFreeSaleType} visibleSubject={true} visibleTo={false} fnAgencyMailPreview={handleAgencyMailPreview} dataSource={exportData} detail={detailData} message={message} />
                        </Spin>
                    </Content>
                </Layout>,
        },
    ];

    const contentStyle: React.CSSProperties = {
        color: token.colorTextTertiary,
        backgroundColor: token.colorFillAlter,
        borderRadius: token.borderRadiusLG,
        border: `1px dashed ${token.colorBorder}`,
        marginTop: 16
    };

    const items = steps.map((item) => ({ key: item.title, title: item.title }));

    const handleBack = () => {
        prev();
    }


    let pageSizes: { name: string; id: number }[] = [{ id: 10, name: "10" }, { id: 25, name: "25" }, { id: 50, name: "50" }, { id: 100, name: "100" }]
    return (
        <>
            <SFModal
                width={window.innerWidth > 768 ? (window.innerWidth * 50 / 100) : window.innerWidth}
                open={openAgencyEmailModal}
                toggler={() => { setOpenAgencyEmailModal(!openAgencyEmailModal) }}
                body={<AgencyEmailTemplate stopFreeSaleType={stopFreeSaleType} activeUser={siteStore.user} activeAgency={activeAgency} dataSource={exportData} detail={detailData} message={message} />}
                title={stopFreeSaleType == enmStopFreeSale.StopSale ? t("stopSaleMailTemplate.emailTitleStop") : t("stopSaleMailTemplate.emailTitleFree")}
            />
            <SFModal
                width={window.innerWidth > 768 ? (window.innerWidth * 50 / 100) : window.innerWidth}
                open={openEmailModal}
                toggler={() => { setOpenEmailModal(!openEmailModal) }}
                body={<StopFreeSaleExportEmail stopFreeSaleType={stopFreeSaleType} closePopup={() => { setOpenEmailModal(false) }} fnAgencyMailPreview={handleAgencyMailPreview} dataSource={exportData} detail={detailData} message={message} />}
                title={t("stopFreeSale.emailTitle")}
            />
            <div className="nk-content ">
                <div className="container-fluid">
                    <div className="nk-content-inner">
                        <div className="nk-content-body">
                            <PageHeaderSection
                                pageTitle={stopFreeSaleType == enmStopFreeSale.FreeSale ? t("stopFreeSale.create.freeSale") : t("stopFreeSale.create.stopSale")}
                            />
                            <div className="nk-block">
                                <div className="row g-gs">
                                    <div className="col-12">
                                        {

                                            <Spin spinning={activeSpin} delay={500}>
                                                <Card className="card card-bordered py-4" loading={createLoading}>
                                                    <Flex justify="end">
                                                        <Button type="default" onClick={handleBack}>{t("common.back")}</Button>
                                                    </Flex>
                                                    <div className="card-inner">
                                                        <Steps current={current} items={items} />
                                                        <div style={contentStyle}>{steps[current].content}</div>
                                                        <Flex justify="end">
                                                            <div style={{ marginTop: 24 }}>
                                                                <Space>
                                                                    {current > 0 && (
                                                                        <Button style={{ margin: '0 8px' }} onClick={() => prev()}>
                                                                            {t("stopFreeSale.create.previousPage")}
                                                                        </Button>
                                                                    )}
                                                                    {current < steps.length - 1 && (
                                                                        <Button type="primary" onClick={() => next()}>
                                                                            {t("stopFreeSale.create.nextPage")}
                                                                        </Button>
                                                                    )}
                                                                    {current == steps.length - 1 && (
                                                                        <Button type="primary" onClick={() => handleCreate()}>
                                                                            {t("common.send")}
                                                                        </Button>
                                                                    )}
                                                                    {current == steps.length - 1 && (
                                                                        <Button type="primary" onClick={() => handleNewActionSendMail(activeItem?.id ?? "")}>
                                                                            {t("stopFreeSale.create.sendMail")}
                                                                        </Button>
                                                                    )}
                                                                    {current == steps.length - 1 && (
                                                                        <Button type="primary" onClick={() => handlePrint(activeItem?.id ?? "")}>
                                                                            {t("stopFreeSale.create.print")}
                                                                        </Button>
                                                                    )}
                                                                    {current == steps.length - 1 && (
                                                                        <Button type="primary" onClick={() => handleExport(activeItem?.id ?? "")}>
                                                                            {t("stopFreeSale.create.pdf")}
                                                                        </Button>
                                                                    )}
                                                                </Space>

                                                            </div>
                                                        </Flex>

                                                    </div>
                                                </Card>
                                            </Spin>
                                        }

                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
}
